
<div class="container p-4" style="    max-width: 1320px;">
    <h3 i18n="@@shoppingcart">Shopping cart</h3>

    <div class="row">
        <div class="col-md-8">
            <app-checkout-customer-details [hidden]="this.registry.checkout_step == 0" #customerDetailsComp></app-checkout-customer-details >

            <app-cart-widget [hidden]="this.registry.checkout_step == 0" #cartWidgetComp></app-cart-widget>


            <app-checkout-shipping-address *ngIf="this.registry?.cart?.items.length>0" [hidden]="this.registry.checkout_step == 0" #shippingAddressesComp></app-checkout-shipping-address>

            <app-shipping-methods *ngIf="this.registry?.cart?.items.length>0" [hidden]="this.registry.checkout_step == 0" #shippingMethodsComp></app-shipping-methods>

            <app-payment-methods *ngIf="this.registry?.cart?.items.length>0" [hidden]="this.registry.checkout_step == 0" #paymentMethodsComponent></app-payment-methods>
        </div>
        <div class="col-md-4">

            <app-cart-summary #summaryComp></app-cart-summary>
        </div>
    </div>


</div>

